export const staticImageBaseUrl =
// todo değiştir
	"https://khicindekocvar.blob.core.windows.net/cdn/eonay/test/Main";

export const logoImage = `${staticImageBaseUrl}/logo.png`;

export const homePageImage = `${staticImageBaseUrl}/home-page-image.png`;

export const notificationLettersImage = `${staticImageBaseUrl}/bildirim-mektuplari.png`;
export const notificationPatternsImage = `${staticImageBaseUrl}/bildirim-sablonlari.png`;
export const reportsImage = `${staticImageBaseUrl}/raporlar.png`;
export const runningTasksImage = `${staticImageBaseUrl}/calisan-islemleri.png`;
export const definitionsImage = `${staticImageBaseUrl}/tanimlamalar.png`;

export const repeatImage = `${staticImageBaseUrl}/repeat.png`;
export const globalRefreshImage = `${staticImageBaseUrl}/global-refresh.png`;
export const loginImage = `${staticImageBaseUrl}/login.png`;
export const closeCircleImage = `${staticImageBaseUrl}/close-circle.png`;

export const helpIconImage = `${staticImageBaseUrl}/help-icon.png`;
export const helpArrowImage = `${staticImageBaseUrl}/arrow.png`;
export const guidesImage = `${staticImageBaseUrl}/kilavuzlar.png`;
export const phoneImage = `${staticImageBaseUrl}/phone.png`;
export const whatsAppImage = `${staticImageBaseUrl}/whatsapp.png`;
export const mailImage = `${staticImageBaseUrl}/mail.png`;
export const webChatImage = `${staticImageBaseUrl}/webchat.png`;

export const androidStoreImage = `${staticImageBaseUrl}/android-store.png`;
export const appStoreImage = `${staticImageBaseUrl}/app-store.png`;
export const blackLogo = `${staticImageBaseUrl}/black-logo.png`;

export const noDataFoundImage = `${staticImageBaseUrl}/no_data.png`;
